import React from 'react';
import logo from './logo.svg';
import './App.css';

import TumbnailCanvas from "./TumbnailCanvas";

function App() {
  return (
        <TumbnailCanvas />
  );
}

export default App;
